import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventDetailsModel } from '../../../../providers/event/event';


/**
 * Generated class for the EventDetailInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-event-detail-info',
  templateUrl: 'event-detail-info.html',
})
export class EventDetailInfoPage {

  @Input("event")
  event: EventDetailsModel;
  @Input("bdValues")
  bdValues: number[] = [];
  bdNames: string[] = ['sflach', 'skflach', 'shuegel', 'sbergig', 'uasphalt', 'uwald', 'ugemischt', 'ucross', 'aumed', 'auurk', 'aushirt', 'augesch', 'podpokal', 'podmed', 'podsach', 'podgeld', 'essstreck', 'essziel', 'esswarm', 'esskuch', 'dusch', 'umkleid', 'wc', 'messe'];

  constructor(public navCtrl: NavController, public navParams: NavParams) {

  }




}



// WEBPACK FOOTER //
// /src/pages/event/details/event-detail-info/event-detail-info.ts